// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"am-z","badgeLink":"bm-z","category":"cm-z"};